
export const SET_MSG = 'ALERTA_MSG';
export const SET_EDITAR = 'ALERTA_EDITAR';
export const SET_LISTA = 'ALERTA_LISTA';